import { render, staticRenderFns } from "./WineMakingNotes.vue?vue&type=template&id=3f6863b4"
import script from "./WineMakingNotes.vue?vue&type=script&lang=js"
export * from "./WineMakingNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports